import { ImageLoader } from "next/image";

const purchaseSourceVehicleImagesLoader: ImageLoader = ({ src }) => {
  return src;
};

export default purchaseSourceVehicleImagesLoader;
